export default __webpack_public_path__ + "static/media/bootstrap.b507b34e.png";